<template>
  <div class="collegues">
    <div class="collegues-container" ref="inner">
      <div v-for="(item, index) in employees" :key="index" class="card">
        <img :src="item.photo" alt="" class="image" />
        <h4 class="name">{{ item.fio }}</h4>
        <h4 class="name-url">№ {{ item.certificate }}</h4>
        <h2 class="position">{{ item.position }}</h2>
      </div>
    </div>
    <div
      v-if="show.spinner"
      style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
    >
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed, onMounted, reactive,  watchEffect } from "vue";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useLanguage } from "@/utils/language";

export default {
  name: "Collegues",

  setup() {
    const store = useStore();

    const activeNews = ref(false);
    const activeIndex = ref(null);
    const desktop = ref(true);
    const show = reactive({
      spinner: true
    });
    const { i18n } = useLanguage();

    onMounted(() => {
      if (window.innerWidth > 375) {
        desktop.value = true;
      } else {
        desktop.value = false;
      }
    });

    const inner = ref(null);
    const scrollEnd = () => {
      show.spinner = false;
    };

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getEmployees", { cb });
      },
      newsCount: computed(() => store.getters.employeesCount),
      currentPage: computed(() => store.getters.employeesPage),
      pageSize: 10,
      scrollEnd
    });

    const refreshData = () => {
      // Necessary to empty the news feed when
      // routing through pages
      store.commit("flushEmployeesState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    // It is not essential to re-run this function
    // but you can if you need to.
    // All it does is just <<restarts>> your page
    refreshData();

    watchEffect(() => i18n.global.locale.value, refreshData);

    return {
      activeNews,
      activeIndex,
      desktop,
      inner,
      show,
      employees: computed(() => store.getters.employees)
    };
  }
};
</script>
<style lang="scss" scoped>
.collegues {
  position: relative;
  margin-top: 25vw;
  z-index: 10;
  width: 100%;
  .collegues-container {
    position: relative;
    width: 90%;
    margin: 0 auto;
    display: grid;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 1rem;
    .card {
      margin-top: 200px;
      width: 320px;
      background: #ffffff;
      border-radius: 0.78vw;
      position: relative;
      cursor: pointer;
      .image {
        width: 228px;
        height: 228px;
        position: absolute;
        border-radius: 0.78vw;
        left: 50%;
        transform: translate(-50%, -75%);
      }
      .name {
        position: relative;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 1.3125em;
        line-height: 1.3;
        text-align: center;
        color: #3e4c60;
        margin-top: 63px;
      }
      .name-url {
        font-style: normal;
        font-weight: 300;
        font-size: 1em;
        line-height: 1.125em;
        text-align: center;
        color: #6c8fba;
        margin: 10px 0 15px 0;
      }
      .position {
        font-family: Open Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 1.75em;
        line-height: 1.2;
        text-align: center;
        color: rgba(62, 76, 96, 0.8);
        padding-bottom: 15px;
      }
    }
  }
}
@media screen and (max-width: 1300px) {
  .collegues {
    margin-top: 50vw;
    .collegues-container {
      .card {
        margin-top: 150px;
        .image {
          width: 200px;
          height: 200px;
          transform: translate(-50%, -70%);
        }
      }
    }
  }
}
@media screen and (max-width: 978px) {
  .collegues {
    margin-top: 30vw;
    .collegues-container {
      // grid-template-columns: 1fr 1fr;
      .card {
        margin-top: 140px;
        border-radius: 1.95vw;
        .image {
          border-radius: 1.95vw;
          transform: translate(-50%, -70%);
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .collegues {
    margin-top: 90vw;
  }
}
@media screen and (max-width: 550px) {
  .collegues {
    .collegues-container {
      .card {
        .position {
          font-size: 24px;
        }
      }
    }
  }
}
@media screen and (max-width: 375px) {
  .collegues {
    margin-top: 115vw;
    .collegues-container {
      width: 81%;
      grid-gap: 108px 7.8vw;
      .card {
        margin-top: 10px;
        border-radius: 9px;
        .image {
          width: 130px;
          height: 130px;
          position: absolute;
          border-radius: 9px;
          left: 50%;
          transform: translate(-50%, -55%);
        }
        .name {
          font-weight: 600;
          font-size: 20px;
          //   margin-top: 1px;
        }
        .name-url {
          font-size: 16px;
          margin: 10px 0;
        }
        .position {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
